<template>
  <div class="special_p">
    <div class="specialtitle">
      <div class="specialtitlediv">
        <img class="specialtitleimg" :src="news.image">
        <div class="specialtitlebox">
          <div class="specialtitlename">{{news.title}}</div>
          <div class="specialtitlecon">{{news.con}}</div>
        </div>
      </div>
    </div>
    <div class="specialcontainer">
      <container :sucais="sucais" :nowsucai="query.type"></container>
    </div>
    <div class="pagbox">
      <el-pagination
        :hideOnSinglePage="total==0"
        background
        layout="prev, pager, next"
        :pageSize="60"
        :total="total"
        @current-change="currentchange"
        :currentPage="parseInt(page)"
        >
      </el-pagination>
    </div>
  </div>
</template>

<script>
const container =()=>import("components/content/container/container.vue")
import {getspecialis} from 'network/app.js'

function getspecialdata(specialstr,id,vue,page=1){
  try{
    const datas = JSON.parse(vue.utils.decrypt(localStorage.getItem(specialstr)))
    ,itemsdata = datas.data
    ,total = datas.total
    ,data_v = datas.data_v
    ,sucai_v = vue.query.type+'_v'
    ,v = data_v[sucai_v]
    if(v != vue.utils.data_v[sucai_v]){throw new Error("版本号对不上获取新的数据")}
    vue.total = total
    vue.sucais = itemsdata
    vue.utils.setalldatas(itemsdata,vue.query.type)
  }catch(e){
    // console.log(e);
    getspecialis(id,vue.query.type,page).then(res=>{
      console.log(res);
      try{
        if(res.total){vue.total = res.total}else{vue.total = 0}
        if(res.data){
          vue.sucais = res.data
          vue.utils.setalldatas(res.data,vue.query.type)
          localStorage.setItem(specialstr,vue.utils.encrypt(JSON.stringify({data:res.data,data_v:vue.utils.data_v,total:res.total})))
        }else{vue.sucais = []}
      }catch(e){vue.sucais = []}
    })
  }
}

export default {
  name:'special_p',
  data() {
    return {
      query:{},
      news:{},
      sucais:[],
      total:0,
      page:1
    }
  },
  components:{
    container
  },
  methods: {
    currentchange(page){
      this.page = page
      this.$el.scrollTop = 0
      const specialstr = 'special'+this.query.id+this.page
      getspecialdata(specialstr,this.query.id,this,this.page)
    }
  },
  created(){
    this.query = this.$route.query
    this.page=1
    const id = this.query.id,specialstr = 'special'+id+this.page
    getspecialdata(specialstr,id,this,this.page)

    this.news = JSON.parse(localStorage.getItem(`nownewslists`))

    // console.log(this.news);
  }
}
</script>

<style>
.specialtitle{
  margin: 30px 58px;
}
.specialtitlediv{
  width: 100%;
  padding-top: 22%;
  position: relative;
  display: flex;
  flex-flow:row nowrap;
  overflow: hidden;
  box-shadow: -2px 2px 6px rgba(0,0,0,0.1);
}
.specialtitleimg{
  position: absolute;
  top: 0px;
  left: 0px;
  width: auto;
  height: 100%;
}
.specialtitlebox{
  position: absolute;
  top: 50%;
  left: 63.3%;
  transform: translate(-50%,-50%);
  width: 50%;
  height: auto;
}
.specialtitlename{
  font-weight: 900;
  font-size: 22px;
  margin-bottom: 10px;
}
.specialtitlecon{
  font-size: 14px;
  color: rgb(112, 117, 126);
}
.specialcontainer{
  margin: 20px 52px 0;
}
.pagbox{
  display: flex;
  margin: 38px auto 80px;
  justify-content:center;
}
</style>